/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { string as codecString } from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { FeedbackBase } from './FeedbackBase';
import { User } from './User';
const FeedbackWithoutRepliesParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(
/* #__PURE__ */ parsers.object([
    ['type', /* #__PURE__ */ parsers.exactly('feedback-without-replies')],
    [
        'user',
        /* #__PURE__ */ codec.record(codecString, 
        /* #__PURE__ */ codec.record(codecString, codecString)),
    ],
    [
        'authors',
        /* #__PURE__ */ codec.record(codecString, 
        /* #__PURE__ */ codec.record(codecString, User)),
    ],
]), FeedbackBase);
export class FeedbackWithoutReplies extends FeedbackBase {
    static decode(input) {
        return FeedbackWithoutRepliesParser.decode(input).map(res => new FeedbackWithoutReplies(res));
    }
    static unsafeDecode(input) {
        return FeedbackWithoutReplies.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return FeedbackWithoutRepliesParser.encode(data);
    }
    static schema() {
        return FeedbackWithoutRepliesParser.schema();
    }
}
